import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as firebase from 'firebase';
import 'firebase/auth';
import * as serviceWorker from './serviceWorker';
import {AuthProvider} from "./Auth";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

/*prod 
var config ={
    apiKey: "AIzaSyB2i07o_A2Hqo9Wk9mV35KcTLmySxoO29U",
    authDomain: "productie-omgeving.firebaseapp.com",
    databaseURL: "https://productie-omgeving-default-rtdb.firebaseio.com",
    projectId: "productie-omgeving",
    storageBucket: "productie-omgeving.appspot.com",
    messagingSenderId: "274979395553",
    appId: "1:274979395553:web:d1367b9ccdaa3d44e724a0"
};*/

//dev
var config ={
  apiKey: "AIzaSyDF1cW4gmAcWz0V6qvDEaWo0xiMShmTiBs",
  authDomain: "kvw-beek.firebaseapp.com",
  databaseURL: "https://kvw-beek-default-rtdb.firebaseio.com",
  projectId: "kvw-beek",
  storageBucket: "kvw-beek.appspot.com",
  messagingSenderId: "422950902382",
  appId: "1:422950902382:web:2080dd12f77b5a1c0b647f"
}
firebase.initializeApp(config);


ReactDOM.render(
<AuthProvider>
<App />
</AuthProvider>

, 
document.getElementById('root'));


